import { ReactNode } from 'react';
import styled from 'styled-components';
import { Flex } from 'dash-ui';

import Footer from 'flow-components/Footer/Footer';
import LogoImg from 'assets/images/png/SignInLogo.png';
import Header from './components/Header/Header';

const Container = styled(Flex)`
  @media ${({ theme }) => theme.devices.tablet} {
    margin-top: 56px;
  }
  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 56px;
  }
`;

const LeftPanel = styled(Flex)<{ backgroundImgSrc: string }>`
  background-image: url(${({ backgroundImgSrc }) => backgroundImgSrc});
  background-repeat: no-repeat;
  background-size: cover;
  max-width: 764px;
  height: calc(100vh - 56px);
  display: flex;
  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    display: none;
  }
`;
const RightPanel = styled(Flex)`
  height: calc(100vh - 56px);
  @media ${({ theme }) => theme.devices.mobile} {
    height: calc(100vh - 160px);
    padding: ${({ theme }) => theme.space * 5.5}px;
  }
  @media ${({ theme }) => theme.devices.tablet} {
    height: calc(100vh - 112px);
  }
  overflow-y: scroll;
`;

function AuthenticationPageLayout({
  children,
  backgroundImgSrc,
}: {
  children: ReactNode;
  backgroundImgSrc: string;
}) {
  return (
    <Flex
      flex={1}
      flexDirection="column"
      alignItems="inherit"
      minHeight="100vh"
    >
      <Header />
      <Container flex={1} flexDirection="row">
        <LeftPanel
          backgroundImgSrc={backgroundImgSrc}
          justifyContent="center"
          alignItems="center"
          flex={1}
        >
          <img src={LogoImg} alt="Dash Logo" />
        </LeftPanel>
        <RightPanel flex={1} justifyContent="center" alignItems="center">
          {children}
        </RightPanel>
      </Container>
      <Footer variation="dark" withSidebar={false} />
    </Flex>
  );
}

export default AuthenticationPageLayout;
